import { Inject } from 'inversify-props'
import { AtributoMarketplace, Page } from '@/models'
import { AxiosRequestConfig } from 'axios'
import type { MarketplaceServiceAdapter } from './adapter'

export class FindAtributoMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	findAllAtributos = async (params: any, config?: AxiosRequestConfig): Promise<Page<AtributoMarketplace>> =>
		this.marketplaceAdapter.findAllAtributos(params, config)

}